<script>
/**
 * @file 课程预约
 */

import {publicOrderClasses, publicHistoryOrder} from '../__mock__/classes';
import ForkissIcon from './forkiss-icon';
import mixin from './mixins_api';

export default {
    mixins: [mixin],
    components: {
        ForkissIcon
    },
    filters: {
        categoryType(value) {
            const obj = {
                '1': '孕期',
                '2': '产后'
            };
            return obj[value];
        }
    },
    computed: {
        statusClass() {
            return function (value) {
                switch (value) {
                    case 6:
                        return 'status-waiting';
                    case 7:
                        return 'status-success';
                    default:
                        return 'status-todo';
                }
            }
        }
    },
    methods: {
        goto() {
            this.$router.push({name: 'private-order'});
        },
        viewDetail(id) {
            this.$router.push({
                name: 'order-detail',
                params: {id}
            });
        },
        handleTouchPlay() {
            let self = this;
            let moveX;
            let startX;
            let movebox = this.$refs.publicContainer;

            // 触摸开始
            function boxTouchStart(e) {
                let touch = e.touches[0];
                startX = touch.pageX;
            }

            function boxTouchMove(e) {
                let touch = e.touches[0];
                moveX = touch.pageX - startX;
            }

            function boxTouchEnd(e) {
                if (moveX > 0) { // 向右

                }

                if (moveX < 0) { // 向左
                    self.$router.push({
                        name: 'private-order'
                    });
                }
            }

            // 滑动对象事件绑定
            movebox.addEventListener('touchstart', boxTouchStart, false);
            movebox.addEventListener('touchmove', boxTouchMove, false);
            movebox.addEventListener('touchend', boxTouchEnd, false);
        }

    },
    created() {
        this.getMyOrder().then(response => {
            this.publicOrderClasses = response.result || [];
        });

        this.getMyHistoryOrder().then(response => {
            this.publicHistoryOrder = response.result || [];

        });
    },
    mounted() {
        // this.$nextTick(function () {
        //     this.handleTouchPlay();
        // });
    },
    data() {
        return {
            // 课程预约
            publicOrderClasses: [],
            // 上课历史
            publicHistoryOrder: []
        };
    }
};
</script>

<template lang="pug">
.forkiss-public-order-container(ref="publicContainer")
    .tabs-box
        .tab-item.active
            span 课程预约
        .tab-item(@click="goto")
            span 私教预约
    .public-order-wrapper
        .order-classes-box(v-for="orderClass in publicOrderClasses",
            data-touch="true",
            @click="viewDetail(orderClass.id)")
            img.classes-img(:src="orderClass.thumb")
            .classes-detail-box
                .status-box.status-success(v-if="orderClass.order_status === '1'") 预约成功
                div
                    .class-type {{orderClass.category | categoryType}}
                    .name {{orderClass.title}}
                    ForkissIcon.time(icon="forkiss-icon-time") {{orderClass.start_time | date("YYYY-mm-dd HH:MM")}}
                    ForkissIcon.address(icon="forkiss-icon-address") {{orderClass.room_name}}
        .history-box-title(v-if="publicHistoryOrder && publicHistoryOrder.length > 0") 上课历史
        .order-classes-box(v-for="orderClass in publicHistoryOrder")
            img.classes-img.status-finish(:src="orderClass.thumb")
            .classes-detail-box
                div
                    .class-type {{orderClass.category | categoryType}}
                    .name {{orderClass.title}}
                    ForkissIcon.time(icon="forkiss-icon-time") {{orderClass.start_time | date("YYYY-mm-dd HH:MM")}}
                    ForkissIcon.address(icon="forkiss-icon-address") {{orderClass.room_name}}
</template>

<style lang="less" scoped>
.forkiss-public-order-container {
    position: relative;
    padding-bottom: 1rem;
    font-size: .24rem;
    background: #f7f7f7;
    height: 100%;
    overflow-y: auto;


    .tabs-box {
        display: flex;
        height: .88rem;
        line-height: .88rem;
        padding: 0 1rem;
        box-shadow: 0 .05rem .08rem 0 rgba(227, 227, 227, .27);
        font-size: .28rem;
        background: #FFF;

        .tab-item {
            position: relative;
            flex: 1;
            color: #828d93;
            text-align: center;

            span {
                position: relative;
            }

            &.active {
                color: #a4805b;

                span::after {
                    content: "";
                    position: absolute;
                    top: 100%;
                    left: 0;
                    right: 0;
                    height: .02rem;
                    background: #a5805a;
                }
            }
        }
    }

    .public-order-wrapper {
        padding: .3rem;
    }

    .order-classes-box {
        position: relative;
        display: flex;
        height: 2.3rem;
        margin-bottom: .3rem;
        box-shadow: 0 .13rem .13rem 0 rgba(4, 26, 55, 0.07);
        background: #FFF;

        * {
            pointer-events: none;
        }

        .classes-img {
            width: 3.12rem;
            height: 100%;
            background: #f0dbca;
            // background-image: url(../assets/order-bg1.png);
            background-size: cover;
            background-position: center;

            &.status-waiting,
            &.status-finish {
                opacity: .6;
            }
        }
        .classes-detail-box {
            position: relative;
            padding-left: .45rem;
            flex: 1;
            display: flex;
            align-items: center;


            .status-waiting {
                position: absolute;
                top: 0;
                right: .36rem;
                width: 1.26rem;
                height: .48rem;
                text-align: center;
                line-height: .5rem;
                background: #ffc68b;
                color: #FFF;
                font-size: .24rem;
            }
            .status-success {
                position: absolute;
                top: 0;
                right: .36rem;
                width: 1.26rem;
                height: .48rem;
                text-align: center;
                line-height: .5rem;
                background: #b0de95;
                color: #FFF;
                font-size: .24rem;
            }
            .class-type {
                color: #999;
                font-size: .2rem;
            }
            .name {
                font-size: .28rem;
                color: #a4805b;
            }
            .time {
                color: #999;
            }
            .address {
                color: #999;
            }
        }
    }

    .history-box-title {
        text-align: center;
        color: #999;
        margin-top: .6rem;
        margin-bottom: .3rem;
        font-size: .24rem;

        &::before {
            content: "";
            display: inline-block;
            width: .66rem;
            height: 1px;
            background: #CCC;
            margin-right: .15rem;
            vertical-align: super;
        }

        &::after {
            content: "";
            display: inline-block;
            width: .66rem;
            height: 1px;
            background: #CCC;
            margin-left: .15rem;
            vertical-align: super;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/public-order.vue